import React from 'react';
import { Todo } from './model';
import SingleToDo from './SingleToDo';
import './styles.css';
import { Droppable } from 'react-beautiful-dnd';

interface Props {
    todos: Todo[];
    setTodos: React.Dispatch<React.SetStateAction<Todo[]>>;
    completedTodos: Todo[];
    setCompletedTodos: React.Dispatch<React.SetStateAction<Todo[]>>;
}

const ToDoList: React.FC<Props> = ({todos, setTodos, completedTodos, setCompletedTodos}) => {
  return (
    <div className="container">
      <Droppable droppableId='TodosList'>
        {
          (provided, snapshot) => (
            <div className={`todos ${snapshot.isDraggingOver ? 'dragactive' : ""}`} ref={provided.innerRef} {...provided.droppableProps}>
              <span className="todos__heading">
                Active Tasks
              </span>
              {
                todos.map((todo, index) => (
                  <SingleToDo 
                    index={index}
                    todo={todo}
                    todos={todos}
                    key={todo.id}
                    setTodos={setTodos}
                  />
                ))
              }
              {provided.placeholder}
            </div>
          )
        }
      </Droppable>
      <Droppable droppableId='TodosRemove'>
        {
          (provided, snapshot) => (
            <div className={`todos remove ${snapshot.isDraggingOver ? "dragcomplete" : ""}`} ref={provided.innerRef} {...provided.droppableProps}>
              <span className="todos__heading">
                Done Tasks
              </span>
              {
                completedTodos.map((todo, index) => (
                  <SingleToDo 
                    index={index}
                    todo={todo}
                    todos={completedTodos}
                    key={todo.id}
                    setTodos={setCompletedTodos}
                  />
                ))
              }
              {provided.placeholder}
            </div>
          )
        }
      </Droppable>
      
    </div>
  )
}

export default ToDoList
 